module.exports = __webpack_public_path__ + "static/media/feuerleoscher_blockiert.003123c9.png";